var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { color } from "../../templates/ui";
import RouterLink from "../../../atoms/Link";
const StyledRouterLink = styled(RouterLink) `
  padding: 10px 0;
  color: ${color.body.base};
  font-size: 13px;
  font-weight: 400;
  transition: color 200ms ease-in-out;
  margin-right: 15px;
  
  &:last-child {
    margin-right: 0;
  }

  &:hover,
  &:focus {
    color: ${color.body.base};
  }
  
  @media only screen and (min-width: 768px) {
    color: ${color.base.light};

    &:hover,
    &:focus {
      color: ${color.base.base};
    }
  }
`;
const MenuItem = (_a) => {
    var { className, href, children, active } = _a, props = __rest(_a, ["className", "href", "children", "active"]);
    return (React.createElement(StyledRouterLink, Object.assign({ href: href, className: className, active: active }, props), children));
};
export default MenuItem;
